import { createContext } from 'react';
export const PlanBuilderContext = /*#__PURE__*/createContext(null);